import React from 'react'
import PropTypes from 'prop-types'
import { DeletedTime, DeletedWrapper } from '../containers/Passages.styles'

const DeletedIrtis = ({ theoreticalTime, isPreSubway, lightMode }) => {
  return (
    <DeletedWrapper data-testid="irtis-deleted">
      <DeletedTime isPreSubway={isPreSubway} lightMode={lightMode}>
        {theoreticalTime}
      </DeletedTime>
    </DeletedWrapper>
  )
}

DeletedIrtis.propTypes = {
  theoreticalTime: PropTypes.string,
  isPreSubway: PropTypes.bool.isRequired,
  lightMode: PropTypes.bool.isRequired,
}

export default DeletedIrtis
